import styles from './Skeleton.module.css';

export interface SkeletonProps {
  readonly width?: string;
  readonly height?: string;
  /** A line of text rather than a block. */
  readonly text?: boolean;
  /** How many to render, for a list. */
  readonly count?: number;
}

/**
 * The shape of content that has not arrived (STD-002 §3.4 — every component that can be loading renders
 * this state).
 *
 * Hidden from screen readers: the loading state is announced once by whatever is waiting, not read out as
 * a series of empty boxes.
 */
export function Skeleton({ width, height, text = false, count = 1 }: SkeletonProps): React.JSX.Element {
  const style = {
    ...(width === undefined ? {} : { width }),
    ...(height === undefined ? {} : { height }),
  };

  return (
    <span aria-hidden="true">
      {Array.from({ length: count }, (_, index) => (
        <span
          key={index}
          className={[styles.skeleton, text ? styles.text : ''].filter(Boolean).join(' ')}
          style={style}
          data-testid="skeleton"
        />
      ))}
    </span>
  );
}
